<template>
<!--设置-->
  <div id="personset">
    <person-head :title="title"></person-head>
    <div class="main">
      <a href="" style="display: none;">
        提交日志
      </a>
      <a href="" style="display: none;">
        清除缓存
      </a>
      <router-link :to="{name: 'Introduction'}">
        关于我们
      </router-link>
    </div>
    <a @click="logout" class="logout" v-if="this.$store.state.uid">退出登录</a>
  </div>
</template>

<script>
import personHead from '../share/header/personHead'
export default {
  name: 'PersonSet',
  data () {
    return {
      title: '设置'
    }
  },
  components: {
    personHead
  },
  methods: {
    logout () {
      this.$store.dispatch('alterName', '')
      this.$store.dispatch('alterNickname', '')
      this.$store.dispatch('alterPeriod', '')
      this.$store.dispatch('alterPortrait', '')
      this.$store.dispatch('alterSchool', '')
      this.$store.dispatch('alterSubject', '')
      this.$store.dispatch('alterToken', '')
      this.$store.dispatch('alterUid', '')
      this.$store.dispatch('alterVipname', '')
      this.$store.dispatch('alterViptime', '')
      console.log(this.$store.state.name)
      console.log(this.$store.state.nickname)
      console.log(this.$store.state.period)
      console.log(this.$store.state.portrait)
      console.log(this.$store.state.school)
      console.log(this.$store.state.subject)
      console.log(this.$store.state.token)
      console.log(this.$store.state.uid)
      console.log(this.$store.state.vipname)
      console.log(this.$store.state.viptime)
      alert('退出成功')
      this.$router.push({name: 'PersonInfo'})
    },
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #personset
    .main
      width: 7.5rem
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a
        display: block
        line-height: .86rem
        border-bottom: .02rem solid #E6E6E6
        font-size: .32rem
        color: #050505
        font-weight: 400
    a.logout
      position: fixed
      bottom: .82rem
      left: 50%
      display: block
      width: 6.7rem
      height: .8rem
      line-height: .8rem
      background-color: #1E81F2
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-border-radius: .4rem
      -moz-border-radius: .4rem
      border-radius: .4rem
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonSet.vue